export default __webpack_public_path__ + "static/media/component_ultrasonic_v2.129f205d.png";